import React from "react";
import { SocialButton, SocialButtons } from "../../../shared/components/copySocialButtons";
import { HtmlRenderBlock } from "../../../core/atoms";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./locationContentSection.scss";

interface Props {
  content: IContentLocationSection;
  region: string;
}

export const LocationContentSection = ({ content, region }: Props) => {
  const id = `content-${content.id}`;
  const socialButtons: SocialButton[] = [
    { platform: "facebook", iconClass: "icon-facebook" },
    { platform: "twitter", iconClass: "icon-twitter" },
  ];
  const country = content.locations[0].slug;
  const wwwBaseUrl = globalConfig.wwwBaseUrl ? globalConfig.wwwBaseUrl : "https://www.travellocal.com";
  const link = wwwBaseUrl + WebRoutes.country(country, region) + `#${content.slug}`;

  return (
    <div id={content.slug} data-scroll-id={id} className="location-content-section blog-post">
      <div className="social-container">
        <SocialButtons
          pageLink={link}
          shortMessage={content.meta.titleTag ? content.meta.titleTag : content.title}
          longMessage={content.meta.descriptionTag ? content.meta.descriptionTag : content.title}
          socialButtons={socialButtons}
          enableCopying={true}
        />
      </div>
      <div className="title-container">
        <h2>{content.title}</h2>
      </div>

      <HtmlRenderBlock htmlString={content?.content?.html} />
    </div>
  );
};
